import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartupService } from './startup.service';
import { AuthService } from './auth.service';
import { SettingsService } from './settings.service';
import { AppInsightsService } from './appInsights.service';
import { SignalRService} from './signalr.service'
import { WorkShiftService } from './workShift.service';
import { HttpHelper } from './http.service';
import { UserMappingService } from './usermapping.service';
import { ScheduleService } from './schedule.service';
import { BusService } from './bus.service';
import { ContextMenuHelper } from '../scheduler/scheduler-upper/context-menu-helper.service';
import { SchedulerUpperService } from '../scheduler/scheduler-upper/scheduler-upper-service';
import { UserImportService } from './userimport.service';
import { SchedulerUpperHelper } from '../scheduler/scheduler-upper/scheduler-upper-helper';
import { UserImportLogService } from './userimportlog.service';
import { LogHelperComponent } from '../user-import-logs/logHelper.component'
import { LoggerService } from './logger.service';
import { LocationService } from './location.service';
import { ReportService } from './report.service';
import { MessageService } from './message.service';
import { SchedulerMediatorService } from '../scheduler/scheduler-mediator.service';
import { ActivityActorService } from './activityActor.service';
import { LiveFlightService } from './liveFlight.service';
import { BfsService } from './bfs.service';
import { DriverScheduleService } from './driverschedule.service';
import { UserActivityService } from './useractivity.service';
import { DispatcherService } from './dispatcher.service';



@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    AuthService,
    StartupService,
    SettingsService,
    AppInsightsService,
    SignalRService,
    WorkShiftService,
    HttpHelper,
    UserMappingService,
    ScheduleService,
    BusService,
    UserImportService,
    ContextMenuHelper,
    SchedulerUpperService,
    SchedulerUpperHelper,
    UserImportLogService,
    LogHelperComponent,
    LoggerService,
    LocationService,
    ReportService,
    MessageService,
    SchedulerMediatorService,
    ActivityActorService,
    LiveFlightService,
    DriverScheduleService,
    BfsService,
    UserActivityService,
    DispatcherService
  ]
})
export class ServicesModule { }
